import { where } from 'firebase/firestore'
import _ from 'lodash'

import { getConvertedData } from '../../../models/interface.helper'
import { getRegistrationEventDataInDb } from '../../../helpers/registration-on-event'
import helpers from '../../../commonHelpers/helpers'

import FirestoreService from '../../../services/firestoreService'
import EventReviewPublishService from '../../../services/firebase-service/event-review-publish/EventReviewPublishService'
import UserService from '../../../services/firebase-service/users/userService'

import {
  IGetMyEventsFilteredDataItem,
  TEventRegisteredUsers,
} from '../../../models/event-registered-users/event-registered-users.interface'

import { EventRegisteredUsersModel } from '../../../models/event-registered-users/event-registered-users.model'
import { EventBookmarkModel } from '../../../models/event-bookmark/event-bookmark.model'

import { CONST } from '../../../const/const'
import RegistrationDyDayService from '../../../services/firebase-service/registration-by-day/RegistrationDyDayService'

const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

export const getUserEvents = async ({
  userId,
  type,
}: {
  userId: string
  type: 'registered' | 'draft' | 'bookmarked'
}) => {
  let eventIds: Set<string> = new Set()
  let registrations: TEventRegisteredUsers[] = []
  let itemsToFilter: IGetMyEventsFilteredDataItem[] = []

  try {
    const { registrationsByDay, registrationsFees, registrationsTickets } =
      await getRegistrationEventDataInDb({
        ownerId: userId,
        type: ['classes', 'fees', 'tickets'],
      })
    const items = [...registrationsByDay, ...registrationsFees, ...registrationsTickets]
    const userIdByItems = _(items).map('userId').uniq().value()
    const userIds = _([userId, ...userIdByItems])
      .uniq()
      .value()

    if (type === 'bookmarked') {
      const bookmarkedSnaps = await FirestoreService.filterItems(COLLECTIONS.EVENT_BOOKMARKS.NAME, [
        where(COLLECTIONS.EVENT_BOOKMARKS.FIELDS.USER_ID.KEY, 'in', userIds),
      ])

      bookmarkedSnaps.docs.forEach((currDoc) => {
        const current = getConvertedData(EventBookmarkModel.fromFirestoreDoc(currDoc).toObject())
        if (current.eventId) eventIds.add(current.eventId)
      })
    } else {
      const queries = [where(COLLECTIONS.EVENT_REGISTERED_USERS.FIELDS.USER_ID.KEY, 'in', userIds)]

      if (type === 'draft') {
        queries.push(where(COLLECTIONS.EVENT_REGISTERED_USERS.FIELDS.IS_REGISTERED.KEY, '!=', true))
      }

      if (type === 'registered') {
        queries.push(where(COLLECTIONS.EVENT_REGISTERED_USERS.FIELDS.IS_REGISTERED.KEY, '==', true))
      }

      const registeredUsersSnaps = await FirestoreService.filterItems(
        COLLECTIONS.EVENT_REGISTERED_USERS.NAME,
        [...queries]
      )
      registeredUsersSnaps.docs.forEach((currDoc) => {
        const current = getConvertedData(
          EventRegisteredUsersModel.fromFirestoreDoc(currDoc).toObject()
        )
        if (current.eventId) {
          eventIds.add(current.eventId)
          registrations.push(current)
        }
      })
    }

    const ids: Set<string> = new Set()
    const eventReviewPublishServiceInDb = await EventReviewPublishService.getByIds([...eventIds])
    eventReviewPublishServiceInDb.forEach((eventReviewPublish) => {
      if (eventReviewPublish.owner) ids.add(eventReviewPublish.owner)
    })
    const usersInDb = await UserService.getByIds([...ids])

    const events = await EventReviewPublishService.getByIds([...eventIds])
    const allRegistrationsByDay = await RegistrationDyDayService.getByEventIds([...eventIds])

    const uniqueSorted = _(registrations)
      .groupBy('eventId')
      .map((group) => {
        const priority = group.find((item) => item.userId === userId)
        return priority ?? group[0]
      })
      .orderBy([(item) => new Date(item.created || '').getTime()], ['desc'])
      .value()

    // We need to how registration which related with "userId" (as registrar) or "eventId" and "userId" (as rider)
    const eventsRelatedWithUser: TEventRegisteredUsers[] = []
    uniqueSorted.forEach((current) => {
      if (current.userId === userId) {
        eventsRelatedWithUser.push(current)
      } else {
        const isExist = items.find(
          (item) => current.eventId === item.eventId && current.userId === item.userId
        )
        if (isExist) eventsRelatedWithUser.push(current)
      }
    })

    eventsRelatedWithUser.forEach((registration) => {
      const event = events.find((event) => event.id === registration.eventId)
      const currentRiders = allRegistrationsByDay.filter(
        (rider) => rider.registrationDocId === registration.id && !rider.isScratched
      )

      const currentOwner = usersInDb.find((user) => user.id === event?.owner)
      if (event?.id) {
        itemsToFilter.push({
          registration: registration,
          event: event,
          riders: currentRiders || [],
          owner: currentOwner || null,
        })
      }
    })

    return itemsToFilter
  } catch (error) {
    console.error(error, 'error')
    helpers.logger({
      isError: true,
      message: error,
    })
    return []
  }
}
